import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit'
import { InvoiceSummary } from '@typings/api/myInvoices.types'
import { MyInvoicesState } from '@typings/store/myInvoicesState.types'

import api from '../../services/api'

const initialState: MyInvoicesState = {
  invoiceSummaries: [
    {
      invoiceDate: '',
      invoiceNo: '',
      invoiceAmount: 0,
    },
  ],
  loading: false,
  error: false,
}

export const fetchMyInvoiceSummary = createAsyncThunk('myInvoices/get', async (_, thunkAPI) => {
  try {
    const response = await api.get<InvoiceSummary[]>({
      url: '/invoices/by-token',
    })
    return response.data
  } catch (error) {
    return thunkAPI.rejectWithValue(error)
  }
})

export const myInvoicesSlice = createSlice({
  name: 'myInvoices',
  initialState,
  reducers: {
    setError: (store, action: PayloadAction<boolean>) => {
      store.error = action.payload
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchMyInvoiceSummary.pending, (state) => {
        state.loading = true
        state.error = false
      })
      .addCase(fetchMyInvoiceSummary.fulfilled, (state, action) => {
        state.loading = false
        state.invoiceSummaries = action.payload
      })
      .addCase(fetchMyInvoiceSummary.rejected, (state, _) => {
        state.loading = false
        state.error = true
      })
  },
})
export const { setError } = myInvoicesSlice.actions
export const myInvoicesReducer = myInvoicesSlice.reducer
